import { createBrowserRouter } from 'react-router-dom';
import { AppShell } from '@/components/layout/AppShell';
import { ROUTES } from './routes';

import { AdminPage } from '@/pages/AdminPage';
import { ArticleReaderPage } from '@/pages/ArticleReaderPage';
import { CopyrightPage } from '@/pages/CopyrightPage';
import { HomePage } from '@/pages/HomePage';
import { LevelReportPage } from '@/pages/LevelReportPage';
import { LoginPage } from '@/pages/LoginPage';
import { NotFoundPage } from '@/pages/NotFoundPage';
import { ProfilePage } from '@/pages/ProfilePage';
import { RegisterPage } from '@/pages/RegisterPage';
import { ReviewPage } from '@/pages/ReviewPage';
import { SentenceLabPage } from '@/pages/SentenceLabPage';
import { StudyAdvicePage } from '@/pages/StudyAdvicePage';
import { TextbookCatalogPage } from '@/pages/TextbookCatalogPage';
import { WordbookPage } from '@/pages/WordbookPage';

/**
 * 路由表。
 *
 * 所有页面都挂在 AppShell 之下（共用顶栏/底部导航/页脚），404 也走同一层，
 * 这样用户在任何地址都不会看到"没有样式的白页"。
 *
 * 说明：这里用 `createBrowserRouter` 的数据路由写法，为后续按页加载数据（loader）
 * 与错误边界留好接口；`*` 兜底必须放在最后。
 */
export const router = createBrowserRouter([
  {
    element: <AppShell />,
    children: [
      { path: ROUTES.home, element: <HomePage /> },
      { path: ROUTES.textbooks, element: <TextbookCatalogPage /> },
      { path: ROUTES.reader(), element: <ArticleReaderPage /> },
      { path: ROUTES.wordbook, element: <WordbookPage /> },
      { path: ROUTES.review, element: <ReviewPage /> },
      { path: ROUTES.level, element: <LevelReportPage /> },
      { path: ROUTES.sentences, element: <SentenceLabPage /> },
      { path: ROUTES.advice, element: <StudyAdvicePage /> },
      { path: ROUTES.profile, element: <ProfilePage /> },
      { path: ROUTES.admin, element: <AdminPage /> },
      { path: ROUTES.login, element: <LoginPage /> },
      { path: ROUTES.register, element: <RegisterPage /> },
      { path: ROUTES.copyright, element: <CopyrightPage /> },
      { path: '*', element: <NotFoundPage /> },
    ],
  },
]);
